import * as Sentry from '@sentry/react';
import { Config } from 'config';
import history from '../../hashHistory';
import shouldFilterEvent from './utils/shouldFilterEvent';
import getEnvironmentName from './utils/getEnvironmentName';
import getMainRouteName from './utils/getMainRouteName';

const initializeSentry = () => {
  const environmentName = getEnvironmentName();
  const isDebugSentryEnabled = process.env.VITE_APP_DEBUG_SENTRY === 'true';

  if (!environmentName || !Config.SENTRY_DSN || Sentry.isInitialized()) {
    return;
  }

  Sentry.init({
    ignoreErrors: ['Non-Error promise rejection captured', 'Non-Error exception captured'],
    dsn: Config.SENTRY_DSN,
    tracesSampleRate: isDebugSentryEnabled ? 1 : 0.1,
    sampleRate: 1.0,
    environment: environmentName,
    integrations: [
      Sentry.breadcrumbsIntegration({ console: false }),
      Sentry.reactRouterV5BrowserTracingIntegration({
        history,
        beforeStartSpan: (options) => {
          const mainRouteName = getMainRouteName(options.name);

          return {
            ...options,
            name: mainRouteName,
            attributes: {
              ...options.attributes,
              'ui.main_route': mainRouteName
            }
          };
        }
      })
    ],
    normalizeDepth: 15,
    release: process.env.VITE_APP_RELEASE_NUMBER || '1.0.0.1',
    beforeSend: (event) => {
      if (shouldFilterEvent(event)) {
        return null;
      }

      return event;
    }
  });
};

export default initializeSentry;
